export const PRICING_ROUTES = {
  FOLLOWER: 'followers',
  FOLLOWING: 'following',
  FRIEND: 'friends',
  INVITATION: 'invitation',
  SUGGESTION: 'suggestions',
  SUGGESTIONPITCH: 'suggestion-pitch',
};
